import { CodelistIntroDialog } from '../../features/codelist/changelog/intro/CodelistIntroDialog';
import { SurveyIntroDialog } from '../../features/entry-form-v2/survey/changelog/SurveyIntroDialog';

export const WhatsNew = () => {
	const shouldShowCodelist = false; // !hasSeenCodelistIntro && codelistEnabled;
	const shouldShowSurvey = false; // !hasSeenSurveyIntro && surveyEnabled;

	// Priority: Codelist > Survey (only one shows at a time)
	const showCodelist = shouldShowCodelist;
	const showSurvey = !shouldShowCodelist && shouldShowSurvey;

	return (
		<>
			{showCodelist && <CodelistIntroDialog />}
			{showSurvey && <SurveyIntroDialog />}
		</>
	);
};
